/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { pitchDeckRejectionDtoSchema } from "./pitchDeckRejectionDtoSchema.ts";
import { pitchDeckReportDtoSchema } from "./pitchDeckReportDtoSchema.ts";
import { z } from "zod/v4";

export const pitchDeckStatusDtoSchema = z.object({
  ingestionStatus: z.optional(
    z.enum(["Scanning", "Extracting", "Ready", "Rejected"]).default("Scanning"),
  ),
  processingStage: z.string().nullish(),
  get ingestionRejection() {
    return pitchDeckRejectionDtoSchema.nullish();
  },
  get report() {
    return pitchDeckReportDtoSchema.optional();
  },
});
